// src/theme/theme.js

import { createTheme } from '@mui/material/styles';
import { lightPalette, darkPalette } from './palette';
import { typography } from './typography';
import { shadows } from './shadows';
import { components } from './components';

export const lightTheme = createTheme({
  palette: lightPalette,
  typography,
  shadows,
  components: {
    ...components,
    MuiCard: {
      styleOverrides: {
        root: {
          ...components.MuiCard?.styleOverrides?.root,
          borderColor: '#E2E8F0', // Slate 200 light border
        },
      },
    },
  },
  shape: {
    borderRadius: 16,
  },
});

export const darkTheme = createTheme({
  palette: darkPalette,
  typography,
  shadows,
  components: {
    ...components,
    MuiCard: {
      styleOverrides: {
        root: {
          ...components.MuiCard?.styleOverrides?.root,
          borderColor: '#1F2937', // Slate 800 dark border
        },
      },
    },
  },
  shape: {
    borderRadius: 16,
  },
});
const themeExport = { lightTheme, darkTheme };
export default themeExport;
